import { Button, ButtonLink, ButtonText } from "ui/gluestack/button";
import { View } from "ui/atoms/view";
import { PermissionCheck } from "../../features/permission/atoms/PermissionCheck";
import { PermissionsEnums } from "../../services/api/types/authorisation/enums/PermissionsEnums";
import { usePathname, useRouter } from "expo-router";
import { ResidentModel } from "../../services/api/types/residents/models/ResidentModel";
import { useReportGenerationContext } from "../../features/reporting/providers/ReportGenerationProvider";
import { DeleteResidentModal } from "app/features/residents/templates/modals/DeleteResidentModal";
import { useState } from "react";
import { useHandleDeleteResident } from "app/features/residents/hooks/useHandleDeleteResident";

type Props = {
  resident?: ResidentModel;
};

export const ResidentProfileActions = ({ resident }: Props) => {
  const { showGenerateReportModal } = useReportGenerationContext();
  const router = useRouter();

  const pathname = usePathname();
  const shouldHideStatusFlagButton = pathname.includes("status-flag");
  const [isDeleteModalVisible, setDeleteModalVisible] = useState(false);

  const goBack = () => {
    router.back();
  };

  const handleDeleteSuccess = () => {
    setDeleteModalVisible(false);
    goBack();
  };

  const { handleDeleteResident, isDeleting } =
    useHandleDeleteResident(handleDeleteSuccess);

  const handleConfirmDelete = () => {
    if (!resident?.id) return;

    handleDeleteResident({
      residentId: resident.id,
    });
  };

  return (
    <View className="flex-row gap-x-4 self-end">
      <DeleteResidentModal
        isVisible={isDeleteModalVisible}
        onClose={() => setDeleteModalVisible(false)}
        isDeleting={isDeleting}
        onSubmit={handleConfirmDelete}
      />
      <PermissionCheck permission={PermissionsEnums.DELETE_RESIDENT}>
        <Button
          variant="outline"
          action="primary"
          size="sm"
          onPress={() => setDeleteModalVisible(true)}
        >
          <ButtonText>Delete Resident</ButtonText>
        </Button>
      </PermissionCheck>
      {!shouldHideStatusFlagButton ? (
        <PermissionCheck
          permission={[PermissionsEnums.UPDATE_RESIDENT]}
          requireAll
        >
          <ButtonLink
            href={`residents/${resident?.id}/status-flags`}
            variant="outline"
            action="primary"
            size="sm"
          >
            <ButtonText>Status Flags</ButtonText>
          </ButtonLink>
        </PermissionCheck>
      ) : null}
      <PermissionCheck permission={PermissionsEnums.GENERATE_RESIDENT_REPORT}>
        <Button
          variant="outline"
          action="primary"
          size="sm"
          onPress={() => showGenerateReportModal(resident)}
        >
          <ButtonText>Generate Report</ButtonText>
        </Button>
      </PermissionCheck>
    </View>
  );
};
